import { types } from "../types/types";

export const getDataProveedores = (values) => ({
  type: types.getDataProveedores,
  payload: values,
});

export const getSelectedDTEs = (values) => ({
  type: types.getSelectedDTEs,
  payload: values,
});

export const getExcludedProviders = (values) => ({
  type: types.getExcludedProviders,
  payload: values,
});

export const getBalances = (values) => ({
  type: types.getBalances,
  payload: values,
});

export const getNominaVencida = (values) => ({
  type: types.getNominaVencida,
  payload: values,
});

export const getNominaSelected = (values) => ({
  type: types.getNominaSelected,
  payload: values,
});

export const getNominaState = (values) => ({
  type: types.getNominaState,
  payload: values,
});

export const getFilterNomina = (values) => ({
  type: types.getFilterNomina,
  payload: values,
})

export const getDataProveedoresFiltered = (values) => ({
  type: types.getNominaFiltered,
  payload: values,
})

export const getInProcessNomina = (values) => ({
  type: types.getInProcessNomina,
  payload: values,
})

export const getProcessedNominas = (values) => ({
  type: types.getProcessedNominas,
  payload: values,
})

export const importDataProveedores = (Nominas) => {
  return async (dispatch) => {
    try {
      dispatch(getDataProveedores(Nominas));
      dispatch(getSelectedDTEs(Nominas.partialAmount));
      dispatch(getExcludedProviders(Nominas.excludedProviders));
    } catch (error) {
      console.error(error);
    }
  };
};

export const importBalances = (balances) => {
  return async (dispatch) => {
    try {
      dispatch(getBalances(balances))
    } catch(error) {
      console.error(error)
    }
  }
}

export const importNominaVencida = (nomina) => {
  return async (dispatch) => {
    try {
      dispatch(getNominaVencida(nomina))
    } catch(error) {
      console.error(error)
    }
  }
}

export const importNominaSelected = (nomina) => {
  return async (dispatch) => {
    try {
      dispatch(getNominaSelected(nomina))
    } catch(error) {
      console.error(error)
    }
  }
}

export const importNominaState = (state) => {
  return async (dispatch) => {
    try {
      dispatch(getNominaState(state))
    } catch(error) {
      console.error(error)
    }
  }
}

export const importFilterNomina = (state) => {
  return async (dispatch) => {
    try {
      dispatch(getFilterNomina(state))
    } catch(error) {
      console.error(error)
    }
  }
}

export const importDataProveedoresFiltered = (state) => {
  return async (dispatch) => {
    try {
      dispatch(getDataProveedoresFiltered(state))
    } catch(error) {
      console.error(error)
    }
  }
}

export const updateProvidersData = (values) => ({
  type: types.updateProviders,
  payload: values,
})

export const updateNominasData = (values) => ({
  type: types.updateNominasInProcess,
  payload: values,
})

export const getUpdateNominaInProcessNeeded = (data) => ({
  type: types.getUpdateNominaInProcessNeeded,
  payload: data,
});

export const importUpdateNominaInProcessNeeded = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getUpdateNominaInProcessNeeded(data))
    } catch (e) {
      console.error(e);
    }
  };
};

export const getUpdateNominaProccesedNeeded = (data) => ({
  type: types.getUpdateNominaProcessedNeeded,
  payload: data,
});

export const importUpdateNominaProccesedNeeded = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getUpdateNominaProccesedNeeded(data))
    } catch (e) {
      console.error(e);
    }
  };
};

export const importUpdateProvidersData = (state) => {
  return async (dispatch) => {
    try {
      dispatch(updateProvidersData(state))
    } catch(error) {
      console.error(error)
    }
  }
}

export const importUpdateNominaData = (state) => {
  return async (dispatch) => {
    try {
      dispatch(updateNominasData(state))
    } catch(error) {
      console.error(error)
    }
  }
}

export const importProcessNomina = (state) => {
  return async (dispatch) => {
    try {
      dispatch(getInProcessNomina(state))
    } catch(error) {
      console.error(error)
    }
  }
}

export const importProcessedNominas = (state) => {
  return async (dispatch) => {
    try {
      dispatch(getProcessedNominas(state))
    } catch(error) {
      console.error(error)
    }
  }
}